/** Quote-local UI state: automatic recipe calculations never create this marker. */
export interface ManualQuotePrice {
  unitCost: number;
  manualPriceBaseline?: number;
}

const pennies = (value: number) => Math.round(value * 100);

export function hasManualPriceOverride(item: ManualQuotePrice): boolean {
  return Number.isFinite(item.manualPriceBaseline)
    && pennies(item.unitCost) !== pennies(item.manualPriceBaseline!);
}

export function manualPriceBaseline(item: ManualQuotePrice, newPrice: number): number | undefined {
  const baseline = item.manualPriceBaseline ?? item.unitCost;
  return Number.isFinite(newPrice) && pennies(newPrice) !== pennies(baseline) ? baseline : undefined;
}
